export const BACKUP_FILENAME_PATTERN = /^[\w,\s-]+/;
export const MONGODB_BACKUP_FILENAME_PATTERN = new RegExp(BACKUP_FILENAME_PATTERN.source + /\.mongodb\.tar\.gz$/.source);
export const INFLUXDB_BACKUP_FILENAME_PATTERN = new RegExp(BACKUP_FILENAME_PATTERN.source + /\.influxdb\.tar\.gz$/.source);